// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__xAs82","Cancel":"schedule_Cancel__vztYM"};